module.exports = __webpack_public_path__ + "img/sequire.803b815b.svg";